/* eslint-disable react/forbid-prop-types */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import findIndex from 'lodash/findIndex';
import flow from 'lodash/flow';
import find from 'lodash/find';
import { shouldHideOption } from '@gcc/configurator';
import ChoiceBoxSelect from '@gcc/pip-components/dist/ChoiceBoxSelect';
import { ChoiceImage } from '@gcc/pip-components/dist/ChoiceBox/styles';
import withIsMobile from '@gcc/pip-components/dist/withIsMobile';
import WarningMessage from '@gcc/pip-components/dist/WarningMessage';
import { OptionErrorMessages } from '@gcc/pip-components/dist/ErrorMessage';
import Carousel from '@gcc/pip-components/dist/Carousel';
import { Context as CollapseContext } from '@gcc/pip-components/dist/collapsibles';
import ConfiguratorTemplate from '../ConfiguratorTemplate';
import { Option, HeaderRow, InlineChoiceSectionHeader } from './styles';

const FixedSizeChoiceImageWrapper = styled.div`
  ${ChoiceImage} img {
    width: 98px;
    height: 94px;
  }
`;

class DefaultTemplate extends React.Component {
  getDefinition = () => {
    const { attributes, option } = this.props;
    return attributes[camelCase(option.shortLabel)];
  };

  getSelectedChoice() {
    const { choices } = this.props;
    return find(choices, 'isSelected');
  }

  getHrefForChoice = (choiceId) => {
    const { configLinks } = this.props;
    return configLinks[choiceId];
  };

  optionChange = (choice) => {
    const { id, shortLabel: choiceValue } = choice;
    const { onChoiceSelected, onChoiceSelectedSuccess, option } = this.props;
    onChoiceSelected(option.id, id, choiceValue)
      .then(() => onChoiceSelectedSuccess());
  };

  render() {
    const selectedChoice = this.getSelectedChoice();
    const {
      option, choices, options, productChoices, isMobile
    } = this.props;
    const choiceInternalName = choices && choices.length > 0 &&
      choices[0].internalName;
    const shouldHide = shouldHideOption(option, options, productChoices);
    return !shouldHide && (choices.length > 1 ||
      (choices.length === 1 &&
        (
          ((choiceInternalName.length >= 3) &&
            ((choiceInternalName.substring(0, 3)) !== 'No_'))
          || (choiceInternalName !== 'No'))
      )) &&
      (
        <CollapseContext.Provider fullCount={choices.length}>
          <Option>
            <HeaderRow>
              <InlineChoiceSectionHeader
                label={option.shortLabel}
                value={selectedChoice && selectedChoice.value}
                definitionMarkdown={this.getDefinition()}
              />
            </HeaderRow>
            <OptionErrorMessages option={option} />
            <FixedSizeChoiceImageWrapper>
              <CollapseContext.Consumer>
                {() => {
                  // TODO this code basically does the following...
                  //   if (mobile)           { return this.mobileRender(context);      }
                  //   else if (collapsible) { return this.collapsibleRender(context); }
                  //   else                  { return this.standardRender(context);    }
                  // ...so make it look like that
                  const selectedChoiceIndex = findIndex(choices, 'isSelected') || 0;
                  const { isRequired, isIndexable } = option;
                  const select = (
                    <ChoiceBoxSelect
                      options={choices}
                      value={choices[selectedChoiceIndex]}
                      keyBy={(choice) => choice.id}
                      labelBy={(choice) => choice.shortLabel}
                      imageBy={(choice) => choice.mediaUrl}
                      onChange={this.optionChange}
                      hrefBy={(choice) => this.getHrefForChoice(choice.id)}
                      indexable={isIndexable && isRequired}
                    />
                  );

                  return isMobile
                    ? <Carousel>{select}</Carousel>
                    : select;
                }}
              </CollapseContext.Consumer>
            </FixedSizeChoiceImageWrapper>
            <WarningMessage option={option} />
          </Option>
        </CollapseContext.Provider>
      );
  }
}

DefaultTemplate.propTypes = {
  choices: PropTypes.array.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    shortLabel: PropTypes.string.isRequired,
    messages: PropTypes.array,
    isRequired: PropTypes.bool.isRequired,
    isIndexable: PropTypes.bool.isRequired,
  }).isRequired,
  options: PropTypes.array.isRequired,
  productChoices: PropTypes.array.isRequired,
  attributes: PropTypes.object.isRequired, // attributes is treated like a dictionary
  onChoiceSelected: PropTypes.func.isRequired,
  onChoiceSelectedSuccess: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  configLinks: PropTypes.object.isRequired,
};

export default flow(
  // include `isMobile` prop
  withIsMobile,
  // connect to redux
  ConfiguratorTemplate,
)(DefaultTemplate);
